import { colorsPalettes } from "@similarweb/styles";

import { getShareValue, getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { keywordGroupsQueryClient } from "app/services/keyword-groups";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { EColumnActions } from "../../common-components/domains-table/Table";

import { dropDownColumnsTexts } from "app/common/keyword-research/serp-players/consts";
import type { DomainData, IData, IEnrichData } from "./types";

export const transformData =
    (isKeywordGroup: boolean, keyword: string, websiteKeywordsState: string, navParams: Record<string, any> = {}) =>
    async (data: IData) => {
        return {
            ...data,
            records: await Promise.all(
                data?.Data?.map(async (record: DomainData) => {
                    const shareOfDesktop = record.DesktopClicks / record.OriginalClicks;

                    const keywordNameForSERP = isKeywordGroup
                        ? (await keywordGroupsQueryClient.getGroupById(keyword))?.Name
                        : keyword;
                    const shareOfOrganicClicks = record.OrganicClicks / record.OriginalClicks;

                    return {
                        ...record,
                        urls: [
                            {
                                name: record.Domain,
                                dropdownItems: [
                                    {
                                        name: EColumnActions[EColumnActions.Explore],
                                        id: record.Domain,
                                        iconName: "search-keywords",
                                        iconSize: "sm",
                                        text: dropDownColumnsTexts.exploreUrlKeywords,
                                        iconColor: colorsPalettes.carbon[200],
                                    },
                                    {
                                        name: EColumnActions[EColumnActions.Copy],
                                        id: record.Domain,
                                        iconName: "organic-site-links",
                                        iconSize: "sm",
                                        text: dropDownColumnsTexts.copyUrlTitle,
                                        iconColor: colorsPalettes.carbon[200],
                                    },
                                    {
                                        name: EColumnActions[EColumnActions.Open],
                                        id: record.Domain,
                                        iconName: "link-out",
                                        iconSize: "sm",
                                        text: dropDownColumnsTexts.openUrlTitle,
                                        iconColor: colorsPalettes.carbon[200],
                                    },
                                ],
                            },
                        ],
                        Share: getShareValue(record.Share),
                        Clicks: getVolumeValue(record.Clicks),
                        selectable: true,
                        href: proNavigator.href(websiteKeywordsState, {
                            ...navParams,
                            key: record.Domain,
                            isWWW: "*",
                        }),
                        WebSourceShare: shareOfDesktop,

                        SearchTerm: keywordNameForSERP,
                        SiteSerpFeatures: { [record.Domain]: record.SerpFeatures },
                        SerpScrapeDate: record.LatestKeywordSerpDate,
                        OrganicClicksShare: shareOfOrganicClicks,
                        Children: record.Children?.map((child) => {
                            const shareOfDesktopDivide = child.DesktopClicks / child.OriginalClicks;
                            const organicClicksShare = child.OrganicClicks / child.OriginalClicks;
                            return {
                                ...child,
                                OrganicClicksShare: organicClicksShare,
                                WebSourceShare: shareOfDesktopDivide,
                                href: proNavigator.href(websiteKeywordsState, {
                                    ...navParams,
                                    key: child.Domain,
                                    isWWW: "*",
                                }),
                            };
                        }),
                    };
                }),
            ),
        };
    };

export const transformDataEnrich = (data: IEnrichData) => {
    return {
        ...data,
        records: data.Data.map((record) => {
            const shareOfOrganicClicks = record.OrganicClicks / record.OriginalClicks;
            return {
                monthlyVolume: getVolumeValue(record.Volume),
                windowVolume: getVolumeValue(record.Volume),
                OrganicClicksShare: shareOfOrganicClicks,
                Intent: {
                    PrimaryIntent: record.PrimaryIntent,
                    SecondaryIntent: record.SecondaryIntent,
                },
                ...record,
            };
        }),
        TotalCount: data.TotalCount,
    };
};
